import { useMemo, useState } from "react";
import { Page, Document as ReactPDF, pdfjs } from "react-pdf";

console.log("legacy: ", pdfjs.version);

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/legacy/build/pdf.worker.min.mjs`;

type PDFViewerProps = {
  fileURL: string;
};

const PDFViewer = ({ fileURL }: PDFViewerProps) => {
  const [numPages, setNumPages] = useState(0);
  const file = useMemo(() => ({ url: fileURL }), [fileURL]);

  return (
    <ReactPDF
      file={file}
      onLoadSuccess={({ numPages }) => setNumPages(numPages)}
      className="flex flex-col items-center gap-4"
    >
      {Array.from(new Array(numPages), (_, index) => (
        <Page
          key={`page_${index + 1}`}
          pageNumber={index + 1}
          renderTextLayer={false}
          renderAnnotationLayer={false}
          // w-fit : le wrapper Page ne s'étire plus plus large que le canvas A4
          className="w-fit border border-[#CBD5E1]"
        />
      ))}
    </ReactPDF>
  );
};

export default PDFViewer;
